import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { z } from 'zod';
import { useMfaComplete } from '../hooks/auth-actions.js';
import { describeError, mergeFormClasses } from './shared.js';
const schema = z.object({ code: z.string().trim().min(4, 'Enter the verification code.') });
/**
 * Renders the multi-factor code field after a `mfa_required` outcome from
 * login. The flow id from the challenge is passed back to the server with the
 * code; the consumer handles routing on success.
 */
export function MfaCodeForm({ challenge, onSuccess, onCancel, classNames, errorMessages, }) {
    const classes = mergeFormClasses(classNames);
    const complete = useMfaComplete();
    const [code, setCode] = React.useState('');
    const [validationError, setValidationError] = React.useState(null);
    const error = describeError(complete.error, errorMessages);
    const handleSubmit = async (event) => {
        event.preventDefault();
        const parsed = schema.safeParse({ code });
        if (!parsed.success) {
            setValidationError(parsed.error.issues[0]?.message ?? 'Enter the code.');
            return;
        }
        setValidationError(null);
        try {
            const result = await complete.run({ flowId: challenge.flowId, code: parsed.data.code });
            onSuccess(result);
        }
        catch {
            // Error captured by hook.
        }
    };
    return (_jsxs("form", { className: classes.form, onSubmit: handleSubmit, noValidate: true, children: [_jsxs("p", { className: classes.hint, children: ["Enter the verification code we sent", challenge.hint !== undefined ? ` to ${challenge.hint}` : '', "."] }), _jsxs("div", { className: classes.field, children: [_jsx("label", { className: classes.label, htmlFor: "auth-ui-mfa-code", children: "Verification code" }), _jsx("input", { id: "auth-ui-mfa-code", className: classes.input, inputMode: "numeric", autoComplete: "one-time-code", required: true, value: code, onChange: (event) => setCode(event.target.value) }), validationError !== null ? (_jsx("p", { className: classes.error, role: "alert", children: validationError })) : null] }), error !== null ? (_jsx("p", { className: classes.error, role: "alert", children: error })) : null, _jsx("button", { type: "submit", className: classes.button, disabled: complete.loading, children: complete.loading ? 'Verifying…' : 'Verify' }), onCancel !== undefined ? (_jsx("button", { type: "button", className: classes.link, onClick: onCancel, children: "Cancel and sign in again" })) : null] }));
}
//# sourceMappingURL=MfaCodeForm.js.map